import { render, staticRenderFns } from "./ScreeningTableListPage.vue?vue&type=template&id=4bfb72c6&scoped=true"
import script from "./ScreeningTableListPage.vue?vue&type=script&lang=js"
export * from "./ScreeningTableListPage.vue?vue&type=script&lang=js"
import style0 from "./ScreeningTableListPage.vue?vue&type=style&index=0&id=4bfb72c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb72c6",
  null
  
)

export default component.exports